/** @jsxImportSource @emotion/react */
import React from 'react';
import { spinnerStyles, circleStyles } from './spinner-loader.styles';

type SpinnerLoaderVariant = 'primary' | 'secondary';

const mapVariantToColor: Record<SpinnerLoaderVariant, string> = {
    primary: '#0057b7',
    secondary: '#F4FAFF',
};

interface SpinnerLoaderProps {
    variant?: SpinnerLoaderVariant;
}

const SpinnerLoader = (props: SpinnerLoaderProps) => {
    const { variant = 'primary' } = props;

    const strokeColor = mapVariantToColor[variant];

    return (
        <div css={spinnerStyles}>
            <svg css={circleStyles} viewBox="0 0 64 64">
                <circle
                    cx="32"
                    cy="32"
                    r="28"
                    fill="none"
                    stroke={strokeColor}
                    strokeWidth="6"
                    strokeLinecap="round"
                    strokeDasharray="50 150"
                />
            </svg>

            <svg css={circleStyles} viewBox="0 0 64 64">
                <circle
                    cx="32"
                    cy="32"
                    r="28"
                    fill="none"
                    stroke={strokeColor}
                    strokeWidth="6"
                    strokeLinecap="round"
                    strokeDasharray="50 150"
                />
            </svg>

            <svg css={circleStyles} viewBox="0 0 64 64">
                <circle
                    cx="32"
                    cy="32"
                    r="28"
                    fill="none"
                    stroke={strokeColor}
                    strokeWidth="6"
                    strokeLinecap="round"
                    strokeDasharray="50 150"
                />
            </svg>

            <svg css={circleStyles} viewBox="0 0 64 64">
                <circle
                    cx="32"
                    cy="32"
                    r="28"
                    fill="none"
                    stroke={strokeColor}
                    strokeWidth="6"
                    strokeLinecap="round"
                    strokeDasharray="50 150"
                />
            </svg>
        </div>
    );
};

export default SpinnerLoader;
